'use client'

export default function Guarantee() {
  const handleGetStarted = () => {
    const contactSection = document.getElementById('contact')
    if (contactSection) {
      const offsetTop = contactSection.getBoundingClientRect().top + window.scrollY - 80
      window.scrollTo({ top: offsetTop, behavior: 'smooth' })
    }
  }

  return (
    <section className="guarantee-section">
      <div className="container guarantee-layout">
        <div className="guarantee-teal-panel">
          <h2 className="guarantee-title">We Take the Risk. You Get the Results.</h2>
          <p className="guarantee-description">$0 to start. We invest our time and expertise upfront—you only pay when your solution is live and delivering value. No deposits, no milestones, no contracts to escape. If it does not work, you owe us nothing.</p>
          <button className="guarantee-button font-logo" onClick={handleGetStarted}>
            <span>Start Risk-Free</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 8L13 8M13 8L9 4M13 8L9 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
        <div className="guarantee-features">
          <div className="guarantee-feature-item">
            <p>$0 development cost—we build it free</p>
          </div>
          <div className="guarantee-feature-item">
            <p>Deployed and managed on our cloud</p>
          </div>
          <div className="guarantee-feature-item">
            <p>Monthly reports so you see the value</p>
          </div>
          <div className="guarantee-feature-item">
            <p>Cancel anytime—no lock-in contracts</p>
          </div>
        </div>
      </div>
    </section>
  )
}
